import { Map as immutableMap } from 'immutable';
import { getField, updateField } from 'vuex-map-fields';
import sleep from '@/utils/sleep';

const STATE = immutableMap({
  date: Date.now(),
});

export const state = () => STATE.toJS();

export const getters = {
  getField,
};

export const mutations = {
  reset(state) {
    Object.assign(state, {
      ...STATE.toJS(),
      date: Date.now(),
    });
  },
  updateField,
};

export const actions = {
  async runVisuals(context, step) {
    await sleep(10);
    await context.dispatch('visualPositions/repositionChildren', null, { root: true });
    await context.dispatch('visualConnectors/setConnectors', null, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
